import service from "@/assets/archetype-service.png";
import product from "@/assets/archetype-product.png";
import retail from "@/assets/archetype-retail.png";
import digital from "@/assets/archetype-digital.png";
import creative from "@/assets/archetype-creative.png";
import franchise from "@/assets/archetype-franchise.png";

export const ARCHETYPE_IMAGES: Record<string, string> = {
  // Legacy keys (kept for backward compat)
  service,
  product,
  retail,
  digital,
  creative,
  franchise,
  // New founder-sim keys (mapped to closest uploaded image).
  // NOTE: marketplace currently reuses the franchise/expansion artwork as the
  // closest visual match (networked/multi-node business). Replace with a
  // dedicated `archetype-marketplace.png` upload when available.
  creator: creative,
  saas: digital,
  marketplace: franchise,
};
